// extracted by mini-css-extract-plugin
export default {"wrapper":"event-module--wrapper--30c5b","title":"event-module--title--e2531","icon":"event-module--icon--7dee1","content":"event-module--content--27b44"};